import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import { cleverTap } from "../../../services/provider/common";
import { CLEVER_TAP_EVENTS, notAttendedReasons } from "../../../constants/provider/constant";
import { toast } from "react-toast";
import moment from "moment";
import { updateRequests } from "../../centralOms/common/apiCalls";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

export default function AttendanceDialog({
  action,
  requestDetails,
  attendanceDialogVisible,
  setAttendanceDialogVisibility,
  fetchData,
  setFetchData,
}) {
  const [feedback, setFeedback] = useState("");
  const [notes, setNotes] = useState("");
  const [notAttendedReason, setNotAttendedReason] = useState("");
  const markAttendance = action === "Attended";

  useEffect(() => {
    if (markAttendance)
      cleverTap(CLEVER_TAP_EVENTS.markAttendedPopupShown, {
        srcType: "web/mWeb",
        srcPage: "appointments/confirmed",
        isPopupShown: 1,
      });
    else
      cleverTap(CLEVER_TAP_EVENTS.markNotAttendedPopupShown, {
        srcType: "web/mWeb",
        srcPage: "appointments/confirmed",
        isPopupShown: 1,
      });
  }, []);

  const submitDetails = async () => {
    try {
      let remarks = markAttendance || notAttendedReason === "Others" ? notes : notAttendedReason;
      cleverTap(markAttendance ? CLEVER_TAP_EVENTS.markAttendedPopupBtnClick : CLEVER_TAP_EVENTS.markNotAttendedPopupBtnClick, {
        srcType: "web/mWeb",
        srcPage: "appointments/confirmed",
        statusInfo: "Customer awaited at DC",
        requestID: requestDetails.id,
        visitType: requestDetails.visitType,
        testCategory: requestDetails.packageName,
        Remarks: remarks,
      });

      setAttendanceDialogVisibility(false);
      let response = await updateRequests(["LABS"], [requestDetails.id], remarks, action, null, null, null, feedback);
      if (response?.success) {
        cleverTap(markAttendance ? CLEVER_TAP_EVENTS.markAttendedSuccess : CLEVER_TAP_EVENTS.markNotAttendedSuccess, {
          srcType: "web/mWeb",
          srcPage: "appointments/confirmed",
          isSuccess: 1,
        });
        setFetchData(!fetchData);
        toast.success("Request updated successfully");
      } else {
        cleverTap(markAttendance ? CLEVER_TAP_EVENTS.markAttendedFailed : CLEVER_TAP_EVENTS.markNotAttendedFailed, {
          srcType: "web/mWeb",
          srcPage: "appointments/confirmed",
          isSuccess: 0,
        });
        toast.error(`Request update failed - ${response?.error}`);
      }
    } catch (err) {
      toast.error(`Request update failed - ${err?.response?.data?.error}`);
    }
  };

  const closePopUp = () => {
    setAttendanceDialogVisibility(false);
  };

  return (
    <Dialog
      open={attendanceDialogVisible}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          closePopUp();
        } else return false;
      }}
      fullWidth={true}
      maxWidth={"md"}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle style={{ background: "rgb(245 245 245)" }}>
        <div className="flex justify-between">
          <div className="font-semibold">
            <span className="cursor-pointer">Confirm Customer Attendance</span>
            <div className="text-xs text-gray-500">
              Request ID <span className="font-semibold">{requestDetails.id} </span>
            </div>
          </div>
          <div className="text-gray-500" onClick={closePopUp}>
            <span className="cursor-pointer">
              <CloseIcon></CloseIcon>
            </span>
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <Box component="form" noValidate autoComplete="off" onSubmit={(event) => submitDetails(event)}>
          <div className="pb-5">
            <div>
              <span className="text-gray-600 text-sm">
                Requested date of visit: <span className="text-red-500 font-semibold"></span>
              </span>
              <span className="text-gray-600 font-semibold text-sm">{moment(requestDetails.fulfillmentDate).format("MMMM Do YYYY hh:mm A")}</span>
            </div>
          </div>

          {markAttendance && (
            <div className="pb-5">
              <FormControl className="w-full pb-10">
                <InputLabel id="feedback">Select your Feedback</InputLabel>
                <Select
                  labelId="feedback"
                  id="feedback"
                  name="feedback"
                  onChange={(event) => setFeedback(event.target.value)}
                  label="Select type of status"
                >
                  <MenuItem value={"Satisfied"}>Satisfied</MenuItem>
                  <MenuItem value={"Dissatisfied"}>Dissatisfied</MenuItem>
                  <MenuItem value={"Pacifistic"}>Pacifistic</MenuItem>
                </Select>
              </FormControl>
            </div>
          )}

          {!markAttendance ? (
            <div>
              <div className="pb-10">
                <FormControl className="w-full">
                  <InputLabel id="notAttendedReason">Reason Not Attended</InputLabel>
                  <Select
                    labelId="notAttendedReason"
                    name="notAttendedReason"
                    id="notAttendedReason"
                    value={notAttendedReason}
                    label="Reject Option"
                    onChange={(event) => {
                      setNotAttendedReason(event.target.value);
                    }}
                    required
                  >
                    {notAttendedReasons.map((ele) => (
                      <MenuItem value={ele}>{ele}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              {notAttendedReason === "Others" ? (
                <div className="pb-10">
                  <FormControl className="w-full">
                    <TextField
                      sx={{ "& .MuiOutlinedInput-input, .MuiInputLabel-root": { fontSize: 14 } }}
                      id="outlined-multiline-static-reject-option"
                      label="Reason For Not Attended*"
                      placeholder="Please Write reason here."
                      name="reasonNotAttended"
                      onChange={(event) => setNotes(event.target.value)}
                      value={notes}
                    />
                  </FormControl>
                </div>
              ) : null}
            </div>
          ) : (
            <div className="pb-10">
              <FormControl className="w-full">
                <TextField
                  sx={{ "& .MuiOutlinedInput-input, .MuiInputLabel-root": { fontSize: 14 } }}
                  id="outlined-multiline-static"
                  label="Remarks*"
                  multiline
                  name="notes"
                  onChange={(event) => setNotes(event.target.value)}
                  rows={4}
                  value={notes}
                />
              </FormControl>
            </div>
          )}

          <div className="pb-5 flex justify-between text-center">
            <div
              className="border border-gray-600 rounded-md w-40 text-gray-900 p-1 text-sm cursor-pointer font-semibold"
              type="submit"
              variant="contained"
              size="large"
              onClick={closePopUp}
            >
              <span>Cancel</span>
            </div>

            {markAttendance ? (
              <div
                className={
                  notes
                    ? "border border-green-600 bg-green-600 text-gray-100 rounded-md w-40 p-1 text-sm cursor-pointer font-semibold"
                    : "border text-gray-100 rounded-md w-40 p-1 text-sm  bg-green-300 border-green-300  font-semibold"
                }
                type="submit"
                variant="contained"
                size="large"
                onClick={notes ? submitDetails : undefined}
              >
                <span>Mark Attended</span>
              </div>
            ) : (
              <div
                className={
                  notAttendedReason.length >= 10 || (notAttendedReason === "Others" && notes)
                    ? "border border-red-600 bg-red-600 text-gray-100 rounded-md w-40 p-1 text-sm cursor-pointer font-semibold"
                    : "border text-gray-100 rounded-md w-40 p-1 text-sm  bg-red-300 border-red-300  font-semibold"
                }
                type="submit"
                variant="contained"
                size="large"
                onClick={notAttendedReason.length >= 10 || (notAttendedReason === "Others" && notes) ? submitDetails : undefined}
              >
                <span>Mark Not Attended</span>
              </div>
            )}
          </div>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
